import React from "react";
import { useQuickSightEC2 } from "@/hooks/useEC2Reports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsEC2Dashboard from "@/components/organisms/EC2Dashboard";

function EC2Reports() {
  const { embedUrl, loading, error, refetch } = useQuickSightEC2();

  return (
    <AWSReportsTemplate
      title="AWS EC2 Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsEC2Dashboard />
    </AWSReportsTemplate>
  );
}

export default EC2Reports;
